import React, { Component } from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import { Modal, ModalFooter, ModalBody, ModalHeader } from "reactstrap";
import { noImg } from "vrcore-dashboard/dist/utilities";
class ToolboxModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toolboxes: props.toolboxes,
            toolboxList: props.selectedToolboxes || [],
        };
    }

    isSelectedItem(uid, list) {
        let ind = false;
        if (list.length <= 0) return false;
        list.map((e, i) => {
            if (uid === e.uid) ind = i;
            return null;
        });
        return ind;
    }

    render() {
        const { toolboxList } = this.state;
        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalHeader>
                    <Typography variant="headline">
                        Select Toolbox Talks
                    </Typography>
                </ModalHeader>

                <ModalBody>
                    <Grid
                        container
                        spacing={2}
                        style={{
                            maxHeight: 400,
                            overflowY: "scroll",
                            overflowX: "hidden",
                        }}
                    >
                        {this.props.toolboxes &&
                            this.props.toolboxes.map((e, i) => {
                                let isSelected = this.isSelectedItem(
                                    e.uid,
                                    toolboxList
                                );
                                return (
                                    <Grid
                                        item
                                        xs={6}
                                        sm={6}
                                        md={4}
                                        lg={3}
                                        xl={3}
                                        key={e.uid}
                                        style={{
                                            border:
                                                isSelected !== false
                                                    ? "2px solid green"
                                                    : "0px solid black",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            let list = toolboxList;
                                            let newItem = {
                                                uid: e.uid,
                                                toolbox_topic:
                                                    e.profile.toolbox_topic,
                                                icon_url: e.profile.icon_url,
                                            };
                                            if (isSelected !== false) {
                                                list.splice(isSelected, 1);
                                                this.setState({
                                                    toolboxList: list,
                                                });
                                            } else
                                                this.setState({
                                                    toolboxList: [
                                                        ...list,
                                                        newItem,
                                                    ],
                                                });
                                        }}
                                    >
                                        <img
                                            src={
                                                e.profile.icon_url !== ""
                                                    ? e.profile.icon_url
                                                    : noImg
                                            }
                                            alt={e.profile.icon_url}
                                            style={{
                                                position: "relative",
                                                width: "90%",
                                                height: "auto",
                                                margin: "0 auto",
                                                display: "block",
                                            }}
                                        />
                                        <Typography
                                            variant="body2"
                                            align="center"
                                        >
                                            {e.profile.toolbox_topic}
                                        </Typography>
                                    </Grid>
                                );
                            })}
                    </Grid>
                </ModalBody>

                <ModalFooter>
                    <div>
                        <Button
                            onClick={() => {
                                this.props.closeModal();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{
                                backgroundColor: "#0188cc",
                                color: "white",
                            }}
                            onClick={() => {
                                this.props.updateToolboxList(toolboxList);
                                this.props.closeModal();
                            }}
                        >
                            Update
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}
export default ToolboxModal;
